import { CommonError } from '../types';

export const isString = (value: unknown): value is string => {
  return typeof value === 'string';
};

export const isObject = (value: unknown): value is Record<string, unknown> => {
  return typeof value === 'object' && value !== null;
};

export const isDomExceptionlError = (value: unknown): value is DOMException => {
  if (!isObject(value)) return false;

  if (
    'code' in value &&
    typeof value.code === 'number' &&
    'message' in value &&
    typeof value.message === 'string' &&
    'name' in value &&
    typeof value.name === 'string'
  ) {
    return true;
  }
  return false;
};

export const isCommonError = (value: unknown): value is CommonError => {
  if (!isObject(value)) return false;

  if (
    'cause' in value &&
    isObject(value.cause) &&
    'errorCode' in value.cause &&
    typeof value.cause.errorCode === 'number' &&
    'errorDescription' in value.cause &&
    typeof value.cause.errorDescription === 'string'
  ) {
    return true;
  }

  return false;
};
